import { KeyboardCapsIcon } from './KeyboardCapsIcon';

/**
 * author: Google
 * id 0F441009-7A1F-45BF-A239-B9591B0A5404
 * name keyboard-caps
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-caps.svg
 * tags
 */
export const KeyboardCapslockIcon = KeyboardCapsIcon;
export default KeyboardCapslockIcon